import { RootState } from "src/shared/types/src";

export const getCommunicationLoading = (state: RootState) => state?.communication?.loading || false;

export const getCommunicationPaginatedLoading = (state: RootState) => state?.communication?.paginatedLoading || false;

export const getCommunicationList = (state: RootState) => state?.communication?.messages || [];

export const getCommunicationCurrentPage = (state: RootState) => state?.communication?.pagination?.currentPage || 1;

export const getCommunicationLastPage = (state: RootState) => state?.communication?.pagination?.lastPage || 1;
